<ng-container *ngIf="type">
    <!-- STOCK -->
    <ng-container *ngIf="type === 'stock' && stockService.shareTicker | async">
        <div class="d-flex card equal p-1 flex-lg-row flex-column justify-content-between align-items-center">
            <ng-container *ngIf="!loading">
                <div class="d-flex status justify-content-center align-items-center">
                    <span class="ng-value-label ticker-select-ml">
                        <img placement="right" [ngbTooltip]="(stockService.shareTicker | async)?.companyName" [src]="'assets/images/ticker-icons/'+(stockService.shareTicker | async)?.ticker+'.png'" width="30px" height="30px" /> {{ (stockService.shareTicker | async)?.ticker }}
                    </span>
                    <p fxLayout="row" fxLayoutAlign="center center" class="mb-0 ml-1">P/%: <span class="value-spacing">{{(stockService.shareTicker | async)?.price | currency: 'USD':'symbol':'1.0-2'}}</span><span>/</span>&nbsp;<span [ngClass]="percentageClass">{{(stockService.shareTicker | async)?.percentageChange | number : '1.0-2'}}%</span></p>
                </div>
                <div class="d-flex status flex-row align-items-center justify-content-between ml-lg-1">
                    <p class="mb-0 mr-2">Long Term Conviction</p>
                    <ticker-value [value]="(stockService.shareTicker | async)?.longTermConviction" [showLabel]="true"></ticker-value>
                </div>
                <div class="d-flex status flex-row align-items-center justify-content-between ml-lg-1">
                    <p class="mb-0 mr-2">Short Term Conviction</p>
                    <ticker-value [value]="(stockService.shareTicker | async)?.shortTermConviction" [showLabel]="true"></ticker-value>
                </div>
                <div class="d-flex status flex-row align-items-center justify-content-between ml-lg-1">
                    <p class="mb-0 mr-2">Favorability</p>
                    <ticker-value [value]="(stockService.shareTicker | async)?.score" [showLabel]="true"></ticker-value>
                </div>
            </ng-container>
            <div class="text-center" *ngIf="loading">
                <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
        </div>
    </ng-container>
    <!-- CRYPTO -->
    <ng-container *ngIf="type === 'crypto' && cryptoService.shareTicker | async">
        <div class="card equal">
            <ng-container *ngIf="!loading">
                <div class="card-header">
                    <h4 class="card-title">Summary</h4>
                </div>
                <div class="card-body">
                    <div class="d-flex justify-content-between align-items-center">
                        <p class="mb-0 transaction-style">Sentiment</p>
                        <ticker-value [value]="(cryptoService.shareTicker | async)?.sentiment" [showLabel]="true"></ticker-value>
                    </div>
                    <div class="d-flex justify-content-between align-items-center">
                        <p class="mb-0 transaction-style">Technical</p>
                        <ticker-value [value]="(cryptoService.shareTicker | async)?.technical" [showLabel]="true"></ticker-value>
                    </div>
                    <div class="d-flex justify-content-between align-items-center">
                        <p class="mb-0 transaction-style">Macro</p>
                        <ticker-value [value]="(cryptoService.shareTicker | async)?.macro" [showLabel]="true"></ticker-value>
                    </div>
                    <div class="d-flex justify-content-between align-items-center">
                        <p class="mb-0 transaction-style">Fundamental</p>
                        <ng-container *ngTemplateOutlet="fundamentalTemp; context: { value: (cryptoService.shareTicker | async)?.onchainAndFundamental }"></ng-container>
                    </div>
                    <div class="d-flex justify-content-between align-items-center">
                        <p class="mb-0 transaction-style">Favorability</p>
                        <ng-container *ngTemplateOutlet="fvtTemp; context: { value: (cryptoService.shareTicker | async)?.favorabilityScore }"></ng-container>
                    </div>
                </div>
            </ng-container>
            <div class="text-center mt-5 pt-5" *ngIf="loading">
                <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
        </div>
        <!-- <div class="d-flex card p-1 flex-lg-row flex-column justify-content-between align-items-center mb-1">
            <div class="d-flex status justify-content-center align-items-center">
                <span class="ng-value-label ticker-select-ml">
                    <img placement="right" [ngbTooltip]="(cryptoService.shareTicker | async)?.companyName" [src]="'assets/images/crypto-icons/'+(cryptoService.shareTicker | async)?.ticker+'.jpg'" width="30px" height="30px" /> {{ (cryptoService.shareTicker | async)?.ticker }}
                </span>
                <p fxLayout="row" fxLayoutAlign="center center" class="mb-0 ml-1">P/%: <span class="value-spacing">{{(cryptoService.shareTicker | async)?.price | currency: 'USD':'symbol':'1.0-2'}}</span><span>/</span>&nbsp;<span [ngClass]="percentageClass">{{(cryptoService.shareTicker | async)?.percentageChange | number : '1.0-2'}}%</span></p>
            </div>
            <div class="d-flex status flex-row align-items-center justify-content-between ml-lg-1">
                <p class="mb-0 mr-2">Sentiment</p>
                <ticker-value [value]="(cryptoService.shareTicker | async)?.sentiment" [showLabel]="true"></ticker-value>
            </div>
            <div class="d-flex status flex-row align-items-center justify-content-between ml-lg-1">
                <p class="mb-0 mr-2">Technical</p>
                <ticker-value [value]="(cryptoService.shareTicker | async)?.technical" [showLabel]="true"></ticker-value>
            </div>
            <div class="d-flex status flex-row align-items-center justify-content-between ml-lg-1">
                <p class="mb-0 mr-2">Macro</p>
                <ticker-value [value]="(cryptoService.shareTicker | async)?.macro" [showLabel]="true"></ticker-value>
            </div>
            <div class="d-flex status flex-row align-items-center justify-content-between mx-lg-1">
                <p class="mb-0 mr-2">Fundamental</p>
                <ng-container *ngTemplateOutlet="fundamentalTemp; context: { value: (cryptoService.shareTicker | async)?.onchainAndFundamental }"></ng-container>
            </div>
            <div class="d-flex status flex-row align-items-center justify-content-between mx-lg-1">
                <p class="mb-0 mr-2">Favorability</p>
                <ng-container *ngTemplateOutlet="fvtTemp; context: { value: (cryptoService.shareTicker | async)?.favorabilityScore }"></ng-container>
            </div>
        </div> -->
    </ng-container>
</ng-container>

<ng-template #fundamentalTemp let-value="value">
    <div [ngSwitch]="value" class="w-full py-1 justify-content-center align-items-center">
      <div *ngSwitchCase="'improving'" class="badge-light-success badge badge-pill px-1"><span>{{value | titlecase}}</span></div>
      <div *ngSwitchCase="'neutral'" class="badge-light-warning badge badge-pill px-1"><span>{{value | titlecase}}</span></div>
      <div *ngSwitchCase="'weakening'" class="badge-light-danger badge badge-pill px-1"><span>{{value | titlecase}}</span></div>
      <div *ngSwitchDefault class="badge badge-pill badge-light-secondary px-1"><span>N/A</span></div>
    </div>
</ng-template>


<ng-template #fvtTemp let-value="value">
    <div class="w-full py-1 justify-content-center align-items-center">
        <ng-container *ngIf="value">
            <div *ngIf="value > 70" class="badge-light-success badge badge-pill px-1">
                <i [data-feather]='"thumbs-up"'></i>
                <span class="center-value">{{value}}</span>
            </div>
            <div *ngIf="value >= 40 && value <= 70" class="badge-light-warning badge badge-pill px-1">
                <i [data-feather]='"shield"'></i>
                <span class="center-value">{{value}}</span>
            </div>
            <div *ngIf="value < 39" class="badge-light-danger badge badge-pill px-1">
                <i [data-feather]='"thumbs-down"'></i>
                <span class="center-value">{{value}}</span>
            </div>
        </ng-container>
        <ng-container *ngIf="!value">
            <div class="badge badge-pill badge-light-secondary px-1">
                <i [data-feather]='"alert-triangle"'></i>
                <span class="center-value">N/A</span>
            </div>
        </ng-container>
    </div>
</ng-template>